import { Link } from "react-router-dom";
import { ArrowLeft, Construction, Mail } from "lucide-react";
import Logo from "../components/app/Logo";

export default function PlaceholderPage({ section, title, description, eta = "Soon" }) {
  return (
    <div
      className="min-h-screen bg-bg-primary text-text-primary"
      data-testid={`placeholder-${section.toLowerCase()}-${title.toLowerCase().replace(/\s+/g, "-")}`}
    >
      {/* Top nav */}
      <nav
        className="w-full border-b border-border-secondary sticky top-0 z-40"
        style={{ background: "rgba(10,10,10,0.85)", backdropFilter: "blur(12px)" }}
      >
        <div className="max-w-[1200px] mx-auto px-6 h-[64px] flex items-center justify-between">
          <Link to="/" style={{ textDecoration: "none" }}>
            <Logo />
          </Link>
          <Link
            to="/"
            data-testid="placeholder-back-home"
            className="motion-micro inline-flex items-center gap-1.5"
            style={{
              fontSize: 13,
              color: "var(--color-text-secondary)",
              height: 36,
              padding: "0 14px",
              borderRadius: 8,
              border: "1px solid var(--color-border-primary)",
              textDecoration: "none",
            }}
          >
            <ArrowLeft size={14} /> Home
          </Link>
        </div>
      </nav>

      {/* Body */}
      <section className="relative">
        <div className="absolute inset-0 hero-glow pointer-events-none" />
        <div className="relative max-w-[760px] mx-auto px-6 py-24 text-center">
          <span
            className="inline-flex items-center gap-2 rounded-full px-3 py-1 mb-7"
            style={{
              background: "var(--color-accent-subtle)",
              border: "1px solid rgba(45,212,191,0.4)",
            }}
          >
            <Construction size={11} color="var(--color-accent)" />
            <span
              className="font-mono"
              style={{ fontSize: 11, letterSpacing: "0.14em", color: "var(--color-accent)" }}
            >
              {section.toUpperCase()} · {eta.toUpperCase()}
            </span>
          </span>

          <h1
            className="text-text-primary mb-5"
            style={{
              fontSize: "clamp(36px, 5vw, 52px)",
              fontWeight: 700,
              letterSpacing: "-0.035em",
              lineHeight: 1.1,
            }}
            data-testid="placeholder-title"
          >
            {title}
          </h1>
          <p
            className="text-text-secondary mb-10 mx-auto"
            style={{ fontSize: 16, lineHeight: 1.65, maxWidth: 540 }}
            data-testid="placeholder-description"
          >
            {description}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/login"
              data-testid="placeholder-cta-primary"
              className="motion-micro inline-flex items-center justify-center gap-2 rounded-[8px]"
              style={{
                background: "var(--color-accent)",
                color: "#0a0a0a",
                height: 44,
                padding: "0 22px",
                fontSize: 14,
                fontWeight: 600,
                textDecoration: "none",
                boxShadow: "0 14px 36px -14px rgba(45,212,191,0.55)",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = "var(--color-accent-hover)")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "var(--color-accent)")}
            >
              Admin sign in
            </Link>
            <a
              href="mailto:hello@guidedsentry.com"
              data-testid="placeholder-cta-secondary"
              className="motion-micro inline-flex items-center justify-center gap-2 rounded-[8px] border"
              style={{
                background: "transparent",
                color: "var(--color-text-primary)",
                borderColor: "var(--color-border-primary)",
                height: 44,
                padding: "0 22px",
                fontSize: 14,
                fontWeight: 500,
                textDecoration: "none",
              }}
            >
              <Mail size={14} /> Get notified
            </a>
          </div>

          <p
            className="font-mono text-text-tertiary mt-10"
            style={{ fontSize: 11, letterSpacing: "0.06em" }}
          >
            Looking for something specific? Email{" "}
            <a
              href="mailto:hello@guidedsentry.com"
              className="motion-micro"
              style={{ color: "var(--color-accent)", textDecoration: "none" }}
            >
              hello@guidedsentry.com
            </a>
          </p>
        </div>
      </section>
    </div>
  );
}
